import { useEffect, useState } from "react";
import API from "../services/api";
import "../styles/dashboard.css";

export default function ManagerClaims() {
  const [claims, setClaims] = useState([]);
  const [dealers, setDealers] = useState([]);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    dealer_id: "",
    dealer_name: "",
    salesman: "",
    category: "",
    status: "",
    from: "",
    to: "",
    search: ""
  });

  const [showDealer, setShowDealer] = useState(false);

  const format = (num) => Number(num || 0).toLocaleString();

  // ================= LOAD CLAIMS =================
  const loadClaims = async () => {
    try {
      setLoading(true);

      const res = await API.get("/manager/claims", {
        params: filters
      });

      setClaims(res.data || []);
    } catch (err) {
      console.log("Load error:", err);
    } finally {
      setLoading(false);
    }
  };

  // ================= LOAD DEALERS =================
  const loadDealers = async () => {
    try {
      const res = await API.get("/manager/dealers");
      setDealers(res.data || []);
    } catch (err) {
      console.log(err);
    }
  };

  // ================= DECISION =================
  const handleDecision = async (id, decision) => {
    try {
      setLoading(true);
      await API.post(`/manager/decision/${id}`, { decision });
      await loadClaims();
    } catch (err) {
      alert("Action failed");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadDealers();
  }, []);

  useEffect(() => {
    loadClaims();
  }, [filters]);

  return (
    <div className="dashboard-container">

      <h2 className="dashboard-heading">Manager Approval</h2>

      {/* ================= FILTER BOX ================= */}
      <div className="top-bar" style={{ flexWrap: "wrap", gap: "10px", position: "relative" }}>

        {/* SEARCH */}
        <input
          className="input"
          placeholder="Search Customer / Mobile"
          value={filters.search}
          onChange={(e) =>
            setFilters({ ...filters, search: e.target.value })
          }
        />

        {/* DEALER SEARCH */}
        <input
          className="input"
          placeholder="Search Dealer"
          value={filters.dealer_name}
          onFocus={() => setShowDealer(true)}
          onChange={(e) =>
            setFilters({
              ...filters,
              dealer_name: e.target.value,
              dealer_id: ""
            })
          }
        />

        {/* DEALER DROPDOWN */}
        {showDealer && filters.dealer_name && (
          <div className="dropdown-box">
            {dealers
              .filter((d) =>
                d.dealer_name
                  .toLowerCase()
                  .includes(filters.dealer_name.toLowerCase())
              )
              .slice(0, 5)
              .map((d) => (
                <div
                  key={d.dealer_id}
                  className="dropdown-item"
                  onClick={() => {
                    setFilters({
                      ...filters,
                      dealer_id: d.dealer_id,
                      dealer_name: d.dealer_name
                    });
                    setShowDealer(false);
                  }}
                >
                  {d.dealer_name}
                </div>
              ))}
          </div>
        )}

        {/* SALESMAN */}
        <input
          className="input"
          placeholder="Salesman Name"
          value={filters.salesman}
          onChange={(e) =>
            setFilters({ ...filters, salesman: e.target.value })
          }
        />

        {/* CATEGORY */}
        <input
          className="input"
          placeholder="Category"
          value={filters.category}
          onChange={(e) =>
            setFilters({ ...filters, category: e.target.value })
          }
        />

        {/* STATUS */}
        <select
          className="input"
          value={filters.status}
          onChange={(e) =>
            setFilters({ ...filters, status: e.target.value })
          }
        >
          <option value="">All Status</option>
          <option value="pending">Pending</option>
          <option value="approved">Approved</option>
          <option value="rejected">Rejected</option>
        </select>

        {/* DATE */}
        <input
          className="input"
          type="date"
          value={filters.from}
          onChange={(e) =>
            setFilters({ ...filters, from: e.target.value })
          }
        />

        <input
          className="input"
          type="date"
          value={filters.to}
          onChange={(e) =>
            setFilters({ ...filters, to: e.target.value })
          }
        />

        {/* RESET */}
        <button
          className="btn btn-reject"
          onClick={() =>
            setFilters({
              dealer_id: "",
              dealer_name: "",
              salesman: "",
              category: "",
              status: "",
              from: "",
              to: "",
              search: ""
            })
          }
        >
          Reset
        </button>

      </div>

      {loading && <p>Processing...</p>}

      {/* ================= TABLE ================= */}
      <div className="table-card">
        <table className="table">
          <thead>
            <tr>
              <th>Salesman</th>
              <th>Dealer</th>
              <th>Category</th> {/* 🔥 ADDED */}
              <th>Customer</th>
              <th>Mobile</th>
              <th>City</th>
              <th>QR</th>
              <th>Date</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {claims.length === 0 ? (
              <tr>
                <td colSpan="11" style={{ textAlign: "center" }}>
                  No claims found
                </td>
              </tr>
            ) : (
              claims.map((c) => (
                <tr key={c.id}>
                  <td>{c.salesman_name}</td>
                  <td>{c.dealer_name}</td>
                  <td>{c.category_name}</td> {/* 🔥 ADDED */}
                  <td>{c.customer_name}</td>
                  <td>{c.customer_mobile}</td>
                  <td>{c.city}</td>
                  <td>{c.qr_value}</td>
                  <td>{new Date(c.created_at).toLocaleDateString()}</td>
                  <td>Rs {format(c.claim_amount)}</td>

                  <td>
                    <span className={`badge badge-${c.manager_status}`}>
                      {c.manager_status}
                    </span>
                  </td>

                  <td>
                    {c.ceo_status === "pending" ? (
                      <>
                        <button
                          className={`btn btn-approve ${
                            c.manager_status === "approved" ? "active" : ""
                          }`}
                          onClick={() => handleDecision(c.id, "approved")}
                        >
                          ✔
                        </button>

                        <button
                          className={`btn btn-reject ${
                            c.manager_status === "rejected" ? "active" : ""
                          }`}
                          onClick={() => handleDecision(c.id, "rejected")}
                        >
                          ✖
                        </button>
                      </>
                    ) : (
                      <span style={{ color: "gray" }}>Locked</span>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* ================= MOBILE ================= */}
      <div className="mobile-cards">
        {claims.map((c) => (
          <div key={c.id} className="mobile-card">
            <h4>{c.customer_name}</h4>

            <p><b>Salesman:</b> {c.salesman_name}</p>
            <p><b>Dealer:</b> {c.dealer_name}</p>
            <p><b>Category:</b> {c.category_name}</p> {/* 🔥 ADDED */}
            <p><b>Mobile:</b> {c.customer_mobile}</p>
            <p><b>City:</b> {c.city}</p>
            <p><b>QR:</b> {c.qr_value}</p>
            <p><b>Amount:</b> Rs {format(c.claim_amount)}</p>

            <span className={`badge badge-${c.manager_status}`}>
              {c.manager_status}
            </span>

            <small>
              {new Date(c.created_at).toLocaleDateString()}
            </small>

            {c.ceo_status === "pending" && (
              <div className="mobile-actions">
                <button
                  className="btn btn-approve"
                  onClick={() => handleDecision(c.id, "approved")}
                >
                  Approve
                </button>

                <button
                  className="btn btn-reject"
                  onClick={() => handleDecision(c.id, "rejected")}
                >
                  Reject
                </button>
              </div>
            )}
          </div>
        ))}
      </div>

    </div>
  );
}